<template>
  <div class="right-column-settings">
    <div class="settings-content__wrapper">
      <div class="horizontal layout center">
        <aha-icon
          name="stopwatch"
          class="settings-icon mb-0.5"
        ></aha-icon>
        <span class="px-2 font-normal">Time limit</span>
        <span class="title-table-presentation-tooltip result-layout-tooltip">
          <b-button
            v-tooltip="timeLimitTooltip"
            class="tooltip-btn"
          />
          <i class="fas fa-question-circle" />
        </span>
      </div>
      <TimeToAnswerConfig />
    </div>
    <div class="settings-content__wrapper">
      <div class="horizontal layout center">
        <aha-icon
          name="award"
          class="settings-icon"
        ></aha-icon>
        <span class="px-2 font-normal">Points</span>
        <span class="title-table-presentation-tooltip result-layout-tooltip">
          <b-button
            v-tooltip="'Choose the points range for this question.'"
            class="tooltip-btn"
          />
          <i class="fas fa-question-circle" />
        </span>
      </div>
      <QuizPointConfig />
    </div>
    <div class="settings-content__wrapper sub-content">
      <div class="horizontal layout center">
        <span class="pr-2 font-normal">Faster answers get more points</span>
        <span class="title-table-presentation-tooltip result-layout-tooltip">
          <b-button
            v-tooltip="fasterAnswerTooltip"
            class="tooltip-btn"
          />
          <i class="fas fa-question-circle" />
        </span>
      </div>
      <QuizFasterAnswerGetMorePointToggle />
    </div>
    <div class="settings-content__wrapper">
      <div class="horizontal layout center">
        <aha-icon
          name="trophy"
          class="settings-icon"
        ></aha-icon>
        <span class="px-2 font-normal">Leaderboard</span>
        <span class="title-table-presentation-tooltip result-layout-tooltip">
          <b-button
            v-tooltip="'Show a leaderboard slide after this question.'"
            class="tooltip-btn"
          />
          <i class="fas fa-question-circle" />
        </span>
      </div>
      <QuizLeaderboardToggle />
    </div>
    <div class="settings-content__wrapper general-quiz-settings" @click="openQuizSettings()">
      <div class="horizontal layout center">
        <aha-icon
          name="setting"
          class="settings-icon"
        ></aha-icon>
        <span class="px-2 font-normal">General quiz settings</span>
      </div>
      <aha-icon name="arrow-no-tail" class="settings-icon__arrow" />
    </div>
  </div>
</template>

<script>
import TimeToAnswerConfig from '@/components-v2/presentation-editor/side-right/TimeToAnswerConfig.vue'
import QuizPointConfig from '@/components-v2/presentation-editor/side-right/QuizPointConfig.vue'
import QuizFasterAnswerGetMorePointToggle from '@/components-v2/presentation-editor/side-right/QuizFasterAnswerGetMorePointToggle.vue'
import QuizLeaderboardToggle from '@/components-v2/presentation-editor/side-right/QuizLeaderboardToggle.vue'

import EventBus from '@/eventBus'

export default {
  components: {
    TimeToAnswerConfig,
    QuizPointConfig,
    QuizFasterAnswerGetMorePointToggle,
    QuizLeaderboardToggle,
  },
  computed: {
    fasterAnswerTooltip() {
      return 'Players score between the max and min points, depending on how quickly they answer correctly.'
    },
    timeLimitTooltip() {
      return 'Choose the maximum time in which players can answer'
    },
  },
  methods: {
    openQuizSettings() {
      EventBus.$emit('show-setting-popup', { defaultExpandedAccordion: 'quiz' })
      this.$store.state.activeModelDetailSlide = false
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss-v2/variables.scss";
.right-column-settings {
  z-index: 9; // https://ahaslides.atlassian.net/browse/AHA-9036
  position: relative;
  & ::v-deep {
    .accordion-item:hover {
      .accordion-item-icon {
        color: inherit;
      }
    }
    .accordion-item-icon {
      color: $secondary-20-color;
    }
    .accordion-item-title-content {
      justify-content: space-between;
      padding: 1rem 0;
    }
  }
  .settings-content__wrapper {
    @apply flex items-center justify-between;
    @apply py-4;
    @apply border-t border-base-30;
    padding-left: 2px;
    &:hover {
      .title-table-presentation-tooltip {
        opacity: 1;
      }
      &.general-quiz-settings {
        @apply text-primary-100;
        .settings-icon, .settings-icon__arrow {
          @apply text-primary-100;
        }
      }
    }
    &.sub-content {
      margin-left: 1.75rem;
      border-top: none;
      padding-top: 0;
    }
    &.general-quiz-settings {
      @apply cursor-pointer;
      .settings-icon__arrow {
        @apply text-secondary-40;
      }
    }
    .settings-icon {
      color: $secondary-60-color;
    }
    .settings-content__link {
      color: inherit;
      text-decoration: underline;
    }
    .title-table-presentation-tooltip {
      opacity: 0;
      transition: all 0.2s ease-in-out;
    }
  }
}
</style>
